import { fromEvent, merge, of } from "rxjs";
import { mapTo } from "rxjs/operators";

export const onlineManager$ = merge(
    of(navigator.onLine),
    fromEvent(window, 'online').pipe(mapTo(true)),
    fromEvent(window, 'offline').pipe(mapTo(false)),
)